import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=7788942e"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"
import style0 from "./Catalog.vue?vue&type=style&index=0&id=7788942e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports